<template>
  <div>
    <label v-if="label" class="block text-xs text-gray-500">
      {{ label }}<span v-if="required"> *</span>
    </label>

    <!-- Boolean (Oui / Non radio buttons) -->
    <div v-if="type === 'boolean'" class="flex items-center gap-4" :class="label ? 'mt-1' : ''">
      <label class="flex items-center gap-1.5 text-sm text-gray-700">
        <input
          type="radio"
          :name="label"
          :checked="modelValue === true"
          @change="emit('update:modelValue', true)"
          class="text-indigo-600 focus:ring-indigo-500"
          :class="error ? 'ring-1 ring-red-300' : ''"
        />
        {{ $gettext("Oui") }}
      </label>
      <label class="flex items-center gap-1.5 text-sm text-gray-700">
        <input
          type="radio"
          :name="label"
          :checked="modelValue === false"
          @change="emit('update:modelValue', false)"
          class="text-indigo-600 focus:ring-indigo-500"
          :class="error ? 'ring-1 ring-red-300' : ''"
        />
        {{ $gettext("Non") }}
      </label>
    </div>

    <!-- Select -->
    <select
      v-else-if="type === 'select'"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value || null)"
      class="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm"
      :class="[label ? 'mt-1' : '', ringClasses]"
    >
      <option :value="null" disabled>{{ placeholder || $gettext("Sélectionner...") }}</option>
      <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
    </select>

    <!-- Input -->
    <input
      v-else-if="type !== 'boolean'"
      :type="type"
      :value="modelValue"
      @input="onInput"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      class="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm"
      :class="[label ? 'mt-1' : '', ringClasses]"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: [String, Number, Boolean], default: null },
  type: { type: String, default: "text" },
  label: { type: String, default: null },
  placeholder: { type: String, default: "" },
  required: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
  options: { type: Array, default: () => [] },
  min: { type: Number, default: undefined },
  max: { type: Number, default: undefined },
});

const emit = defineEmits(["update:modelValue"]);

const ringClasses = computed(() =>
  props.error
    ? "ring-red-300 focus:ring-2 focus:ring-red-500"
    : "ring-gray-300 focus:ring-2 focus:ring-indigo-600"
);

const onInput = (event) => {
  const val = event.target.value;
  emit("update:modelValue", props.type === "number" ? (val === "" ? null : Number(val)) : val);
};
</script>
